export const Errors = {
    ERROR_EMPTY_TASK_USER_SELECTION: "errorEmptyTaskUserSelection",
    ERROR_EMPTY_BALANCE_USER_SELECTION: "errorEmptyBalanceUserSelection",
    ERROR_EMPTY_BILLABLE_USER_SELECTION: "errorEmptyBillableUserSelection",
    ERROR_EMPTY_OVERTIME_USER_SELECTION: "errorEmptyOvertimeUserSelection",
    ERROR_EMPTY_CP_SELECTION: "errorEmptyCPSelection",
    ERROR_EMPTY_LEAVE_TYPES_SELECTION: "errorEmptyLeaveTypesSelection",
    ERROR_INCORRECT_DATE_RANGE: "errorIncorrectDateRange"
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/constants.js